import _ from 'lodash';
import Request from '../../services/Requests.js';
import axios from 'axios';

import Cookies from 'js-cookie';
import * as types from '../mutation-types';

// state
export const state = {
    user: null,
    userId: null,
    token: Cookies.get('token')
};

// mutations
export const mutations = {
    [types.SAVE_TOKEN] (state, { token, remember }) {
        state.token = token;
        Cookies.set('token', token, { expires: remember ? 365 : null });
    },

    [types.FETCH_USER_SUCCESS] (state, { user }) {
        if (user && user.id > 0) {
          state.userId = user.id;
        }
        state.user = user;
    },

    [types.FETCH_USER_FAILURE] (state) {
        state.token = null;
        Cookies.remove('token');
    },

    [types.LOGOUT] (state) {
        state.user = null;
        state.token = null;

        Cookies.remove('token');
    },

    [types.UPDATE_USER] (state, { user }) {
        state.user = user;
    }
};

// actions
export const actions = {
    saveToken ({ commit, dispatch }, payload) {
        commit(types.SAVE_TOKEN, payload);
    },

    async fetchUser ({ commit }) {
        try {
            const { data } = await (new Request({ promise: false }))
                .get('/user');

            if (data) {
                if (_.isArray(data.data)) {
                    commit(types.FETCH_USER_SUCCESS, { user: _.first(data.data) });
                } else {
                    commit(types.FETCH_USER_SUCCESS, { user: data.data });
                }
            } else {
                commit(types.FETCH_USER_FAILURE);
            }
        } catch (e) {
            commit(types.FETCH_USER_FAILURE);
        }
    },

    updateUser ({ commit }, payload) {
        commit(types.UPDATE_USER, payload);
    },

    async logout ({ commit }) {
        try {
            await axios.post('/api/logout');
        } catch (e) {
        }

        commit(types.LOGOUT);
    }
};

// getters
export const getters = {
    authUser: state => state.user,
    authToken: state => state.token,
    authCheck: state => state.user !== null,
    authUserId: state => state.userId
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/auth.js